<template>
  <div>
    <header id="masthead">
        <div class="wp1200">
            <div class="flex">
                <a class="logo" href="">{{ $t("home.header_title") }}</a>
            <router-link :to="{ name: 'login', query: { activeTab: 'login' }}"  class="login txt">                
                <span class="warpit_icon_user icon"></span>
                {{ $t("home.login") }}
            </router-link>                            

            </div>
        </div>
    </header>    
  </div>
</template>
<script>
export default {
  
};
</script>
<style scoped src="@/assets/css/bootstrap.css"></style>
<style>
</style>